import { ca } from '@cian/analytics';

export function trackPersonTypeClick(personType: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Profile_user_comm_popup',
    action: 'Click',
    label: `Step_4_${personType}`,
  });
}
